import { ChipsideComponent } from "../chipside-component";

export class DropdownGroup extends ChipsideComponent {
	constructor() {
		super();

		this.label = this.getAttribute("label") ?? "";
		this.size = this.getAttribute("size") ?? "5";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("chip-header", this.label, { size: this.size }));
	}
}